export const ID = 'b4110aef-ca4c-48bf-acaf-a126f866df40';

export const NAME = 'Text Box';
